import React, { useState} from "react";import CustomSnackbar from '../Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import { EditingLineOptic } from '../WriteData/WriteCantonCommunications';
import { updateWithClosestHouse, updateWithEditingClosestHouse } from './LinePolygons';
import { CONST_CANTON } from "../Constants/ConstantsOptics";

const ModalEditingCable = ({ isEditing, setLinkEditing, setPolylinePoints, lineEditing, lengthCableEditing, 
        lineId, user, setLineId, highwayRefresh, setLineEditing, markerEditing, cantonRefresh, handleEditingCancelClick,
        housesData}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
   const [isCheckedStartEnd, setIsCheckedStartEnd] = useState(false);
   const [isCheckedConnection, setIsCheckedConnection] = useState(false);

  const saveEditingLine = async () => {
   
     const updated = updateWithEditingClosestHouse(lineEditing, housesData, 6);
             // обновим точки
    
    EditingLineOptic(lineId, updated,lengthCableEditing, markerEditing, user, setLineEditing,
                     setLineId, setLinkEditing, highwayRefresh, showSnackbar, cantonRefresh,
                     setPolylinePoints, isCheckedStartEnd, setIsCheckedStartEnd, isCheckedConnection, setIsCheckedConnection);
    }  

    if (isEditing) {
    return (
      <div className="divCurrentLengthCable">
         <label style={{ color: '#d1d1d1', fontSize: "16px" }}>Редактирование кабеля</label>
         <hr className='horizontalLineDialog2'/>
        <label style={{ color: '#ebebeb', marginBottom: "5px" }}>Длина кабеля: <span style={{ color: '#fcc205' }}>{lengthCableEditing}  м.</span></label>
        <hr className='horizontalLineDialog2'/>
        {markerEditing === CONST_CANTON && (
          <>
            <label style={{ color: '#ebebeb', marginTop: '5px', marginBottom: '0px', display: 'flex', alignItems: 'center' }}>
            <input 
              type="checkbox" 
              checked={isCheckedStartEnd} 
              onChange={(e) => {
                setIsCheckedStartEnd(e.target.checked);
              }} 
              style={{ marginRight: '8px' }}
            />
            обновить start/end
          </label>
        </>
        
      )}
       <>
            <label style={{ color: '#ebebeb', marginTop: '5px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
            <input 
              type="checkbox" 
              checked={isCheckedConnection} 
              onChange={(e) => {
                setIsCheckedConnection(e.target.checked);
              }} 
              style={{ marginRight: '8px' }}
            />
            обновить связи
          </label>
        </>
        <button  class='buttonEditingLineSave'style={{marginRight: "5px"}} onClick={saveEditingLine} > Сохранить изменения</button>
        <button  class='buttonEditingLineСancel' onClick={handleEditingCancelClick}> Отмена</button>

      {/* Snackbar */}
      <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }         
        }}
      />       
      </div>
    );
    
  } else {
    return null;
  }  
}

export default ModalEditingCable;